import BoldText from '@/components/BoldText';
import { config } from '@/config';
import { BlockStack, Button, Card, InlineStack, Link, Select, SkeletonBodyText } from '@shopify/polaris';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isThankYouPage?: boolean;
  isLoading?: boolean;
  checkoutProfileOptions?: {
    value: string;
    label: string;
  }[];
}

export const ExtensionCard = ({ isThankYouPage, isLoading, checkoutProfileOptions }: Props) => {
  const { t } = useTranslation('widget_settings');
  const key = useMemo(() => (isThankYouPage ? 'thank-you' : 'order-status'), [isThankYouPage]);
  const [checkoutProfileId, setCheckoutProfileId] = useState('');

  const handleAddCheckoutBlock = () => {
    const shopName = config.storeName;
    const link = `https://admin.shopify.com/store/${shopName}/settings/checkout/editor/profiles/${checkoutProfileId}?context=apps&page=${key}`;
    window.open(link, '_blank');
  };

  useEffect(() => {
    setCheckoutProfileId(checkoutProfileOptions?.[0].value || '');
  }, [checkoutProfileOptions]);

  if (isLoading) {
    return (
      <Card padding={'300'}>
        <SkeletonBodyText lines={7} />
      </Card>
    );
  }

  return (
    <Card>
      <BlockStack gap={'400'}>
        <InlineStack align="space-between" blockAlign="center">
          <BoldText>{t(`position.extensionCard.${key}.title`)}</BoldText>
          <Link
            onClick={() =>
              window.open(
                'https://help.omegatheme.com/en/article/how-to-add-selected-date-and-time-on-thank-you-page-order-status-page-1e11sdo/',
              )
            }
          >
            Learn more
          </Link>
        </InlineStack>
        <Select
          label={t(`position.extensionCard.${key}.selectTitle`)}
          helpText={t(`position.extensionCard.${key}.selectHelpText`)}
          options={checkoutProfileOptions}
          value={checkoutProfileId}
          onChange={(value) => setCheckoutProfileId(value)}
        />
        <InlineStack>
          <Button variant="primary" onClick={handleAddCheckoutBlock}>
            {t(`position.extensionCard.${key}.addBtn`)}
          </Button>
        </InlineStack>
      </BlockStack>
    </Card>
  );
};
